export default async function auth({ next, router }) {
    await axios
        .get('/api/travel-plus/subscription/status')
        .then((response) => {
            if (!response.data.active) {
                router.push('/10xtravel-plus/upgrade');
            }
        })
        .catch((response) => {
            router.push('/10xtravel-plus/upgrade');
        });

    return next();
}
